import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext({ user: null, loading: true, refresh: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const r = await api.get("/auth/me");
            setUser(r.data);
        } catch { setUser(null); }
        setLoading(false);
    }, []);

    useEffect(() => {
        // If returning from OAuth (has session_id in URL fragment), skip /me check.
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        refresh();
    }, [refresh]);

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch {}
        setUser(null);
        window.location.href = "/login";
    };

    return (
        <AuthContext.Provider value={{ user, loading, refresh, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);

export const ROLE_LEVEL = { accountant: 1, invoicing_staff: 2, admin: 3 };
export const canDo = (user, minRole) => user && (ROLE_LEVEL[user.role] || 0) >= (ROLE_LEVEL[minRole] || 99);
